var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{class:_vm.pluginNameClass},[_vm._v(_vm._s(_vm.pluginName))]),_c('div',{class:_vm.powerdByClass},[_c('p',[_vm._v(_vm._s(_vm.powerdBy))])])])}
var staticRenderFns = []

export { render, staticRenderFns }